/*
* @desc 工具类
* */

import jointImageSuffix from '@kkmh/image-format';

/*
* 处理图片后缀(仅用于服务端下发的链接拼接，本地的不使用这种）
* 可查看图片处理sdk {@link https://wiki.quickcan.com/pages/viewpage.action?pageId=36244672}
* @param {Object} imageInfo
* @param {string} [imageInfo.value=''] - 图片地址
* @param {number | string} imageInfo.width - 图片展示宽度（以750px设计稿为基数）
* @param {string} [imageInfo.q=h] - 要展示的图片的质量（h：高质量；l：低质量）
* @param {boolean} [imageInfo.p=false] - 是否支持图片渐进式
* @param {boolean} imageInfo.social - 是否是社区图片
* @return {string}
* */
export const _dealImageSuffix = ({value: originSrc = '', width, q = 'h', p = false, social}) => {
    if(!originSrc) {
        return '';
    }

    let isSocial = false;
    if(social === void 0) {
        //let socialDomainReg = /f(1|1s|5|6)\.kkmh\.com/;
        let videoDomainReg = /video-social\.kkmh\.com/;
        let videoDomainRegStag = /video-social-stag\.kkmh\.com/;
        let avatarDomainReg = /(f[234]|(f2)|i1s|f12stag)\.kkmh\.com/;

        if(videoDomainReg.test(originSrc)) {
            return originSrc;
        }
        if(videoDomainRegStag.test(originSrc)) {
            return originSrc;
        }

        /*
        * 判断是否是社区图片(社区图片不截取）
        * */
        isSocial = !avatarDomainReg.test(originSrc) || originSrc.indexOf('tncache1-f1.v3mh.com') > -1;
    } else {
        isSocial = !!social;
    }

    return jointImageSuffix({src: originSrc, width: width, quality: q, p, intercept: !isSocial});
}

